import {Injectable} from '@angular/core';
import {
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    Router,
    ActivatedRoute
} from '@angular/router';
import {UserAuthenticationService, AclService} from '@galec/services';
import {LangService} from "@galec/services/global/lang.service";

@Injectable({
    providedIn: 'root'
})
/**
 * ACL Guard to verify that user has correct permission to access.
 */
export class AclGuard implements CanActivate {
    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private userAuthenticationService: UserAuthenticationService,
        private aclService: AclService,
        private readonly langService: LangService,
    ) {
    }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot) {
        const currentUser = this.userAuthenticationService.currentUserValue;
        const routeName = next.data.name;
        if (!currentUser.roles) {
            return false;
        } else if (routeName.length === 0 || !this.aclService.can(routeName)) {
            // If not logged, redirect to login with current url.
            this.langService.navigate('/403', {returnUrl: state.url});
            return false;
        }
        return true;
    }
}
